import { render, staticRenderFns } from "./LabtechDetailsView.vue?vue&type=template&id=32a0bd79"
import script from "./LabtechDetailsView.vue?vue&type=script&lang=js"
export * from "./LabtechDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports